import { C, SERVICES, IMG_COLORS, IMG_LABELS } from "../data/constants";

export default function Services({ onServiceClick }) {
  return (
    <section id="services" className="section-pad" style={{ background: C.cream }}>
      <div className="container">
        <div className="section-header fade">
          <p className="eyebrow" style={{ color: C.blush, letterSpacing: 3, textTransform: "uppercase", fontSize: 11, marginBottom: 10 }}>What We Create</p>
          <h2 style={{ fontSize: "clamp(28px,4vw,48px)", fontWeight: 300, color: C.dark, marginBottom: 14 }}>Our Services</h2>
          <div style={{ width: 48, height: 1, background: C.blush, margin: "0 auto 16px" }} />
          <p style={{ color: C.mid, maxWidth: 520, margin: "0 auto", lineHeight: 1.8, fontSize: "clamp(13px,1.5vw,15px)" }}>
            From intimate proposals to grand celebrations — we design every detail with love and precision.
          </p>
        </div>

        <div className="services-grid">
          {SERVICES.map((s, i) => (
            <div key={i} className="fade lift"
              style={{ background: C.white, borderRadius: 16, overflow: "hidden", cursor: "pointer" }}
              onClick={() => onServiceClick(s)}>
              <div style={{ height: "clamp(160px,20vw,200px)", background: IMG_COLORS[s.imgIdx], position: "relative", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <div style={{ textAlign: "center", color: "rgba(255,255,255,0.65)" }}>
                  <div style={{ fontSize: 32, marginBottom: 4 }}>📷</div>
                  <div style={{ fontSize: 11 }}>{IMG_LABELS[s.imgIdx]}</div>
                </div>
                <div style={{ position: "absolute", top: 10, left: 10, background: "rgba(205,172,161,0.9)", color: C.white, fontSize: 10, letterSpacing: 1.5, textTransform: "uppercase", padding: "4px 11px", borderRadius: 18 }}>{s.tag}</div>
                <div style={{ position: "absolute", bottom: 10, right: 10, background: "rgba(44,40,38,0.8)", color: C.sand, fontSize: 12, padding: "4px 11px", borderRadius: 16 }}>{s.price}</div>
              </div>
              <div style={{ padding: "18px 20px 22px" }}>
                <h3 style={{ fontSize: "clamp(16px,2vw,19px)", fontWeight: 600, color: C.dark, marginBottom: 7 }}>{s.title}</h3>
                <p style={{ color: C.mid, fontSize: 13, lineHeight: 1.75 }}>{s.desc}</p>
                <button style={{ marginTop: 14, background: "none", border: `1px solid ${C.blush}`, color: C.blush, padding: "6px 15px", borderRadius: 16, fontSize: 12, cursor: "pointer" }}>
                  View Details →
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}